/**
 * The API's renderer wraps every successful POST/PUT/PATCH/DELETE body as
 * `{ status, details: { type, message, description, data } }`, so the payload
 * a client wants sits at `details.data`. GETs are returned bare.
 *
 * Reading `response.data` as the payload therefore yields the envelope on the
 * write paths, and the mismatch is silent — a cast makes the fields simply
 * read `undefined` (EAD-477). Route every write response through this.
 *
 * The bare fallback is deliberate: it keeps the helper correct for GETs and
 * for any endpoint that opts out of the envelope via `skip_envelope`.
 */
interface Enveloped<T> {
  details?: { data?: T }
}

export const unwrapEnvelope = <T>(data: unknown): T => {
  const details = (data as Enveloped<T> | null | undefined)?.details
  // Presence, not nullishness: a write with no body renders as
  // `details.data: null`, and `??` would hand the envelope back instead.
  return details && "data" in details ? (details.data as T) : (data as T)
}
